/**
 * Path: packages/frontend/src/core/directives/can.ts
 * Task: Vue 3 directive (v-can) conditionally hiding or disabling DOM elements based on capabilities.
 */
import { Directive, DirectiveBinding } from 'vue';
import { useAuthStore } from '@/store/auth';

function evaluateCapability(el: HTMLElement, binding: DirectiveBinding<string | string[]>): void {
  const authStore = useAuthStore();
  const rawValue = binding.value;

  if (!rawValue) return;

  const requiredCapabilities = Array.isArray(rawValue) ? rawValue : [rawValue];
  const isAppAdmin = authStore.isAppAdmin;

  const hasAccess = isAppAdmin || requiredCapabilities.every(cap => authStore.effectiveCapabilities.includes(cap));

  // Modifier: v-can.disable="..." sets disabled attribute instead of hiding
  if (binding.modifiers.disable) {
    if (!hasAccess) {
      el.setAttribute('disabled', 'true');
      el.classList.add('v-btn--disabled', 'pointer-events-none', 'opacity-50');
      (el as any).disabled = true;
    } else {
      el.removeAttribute('disabled');
      el.classList.remove('v-btn--disabled', 'pointer-events-none', 'opacity-50');
      (el as any).disabled = false;
    }
  } else {
    // Default: Toggle display visibility
    if (!hasAccess) {
      el.style.display = 'none';
    } else {
      el.style.display = '';
    }
  }
}

export const canDirective: Directive = {
  mounted(el, binding) {
    evaluateCapability(el, binding);
  },
  updated(el, binding) {
    evaluateCapability(el, binding);
  }
};
